
import React, { Component } from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import ButtonAppBar from './material-ui/ButtonAppBar';

import theme from '../helpers/Theme';

const styles = theme => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },        
});



const centerText = {
    textAlign: 'Center',
}

class RecycleBin extends Component{

    constructor(props) {
        super(props);
        this.state = {
            recycleFS: [],
        }

        this.handleRestore = this.handleRestore.bind(this);
        this.handleMenuChange = this.handleMenuChange.bind(this);
        this.clearRecycleBin = this.clearRecycleBin.bind(this);

    }

    clearRecycleBin(event){
        event.preventDefault();
        this.state.recycleFS.map((docSnapshot) => {
            const db = firebase.firestore();
            const uid = firebase.auth().currentUser.uid;
            const deleteRead = "deleteRead."+ uid;
            const deleteWrite = "deleteWrite."+ uid;
            db.collection("persons").doc(docSnapshot.id).update({
                [deleteRead]: firebase.firestore.FieldValue.delete(),
                [deleteWrite]: firebase.firestore.FieldValue.delete(),
            })
            .then(() => {
                console.log("document deleted.");
            })
            .catch(function(error) {
                console.error("failed delete document: ", error);
            });
            return true;
        });

        this.props.history.push('/');

    }

    handleOnSnapshot(querySnapshot) {
        const docs = querySnapshot.docs;
        this.setState({ 
            recycleFS: docs,
            menuOpen: null,
         });
        
    }

    componentDidMount() {
        const uid = firebase.auth().currentUser.uid;
        var db = firebase.firestore();

        this.unsubscribe = db.collection("persons").where("deleteRead." + uid, "==", true)
            .onSnapshot(
                this.handleOnSnapshot.bind(this)
            );
    }

    componentWillUnmount() {
        this.unsubscribe()
    }

    handleRestore(docSnapshot, event){
        event.preventDefault();
        let isReadOnly = true;
        const data = docSnapshot.data();
        const uid = firebase.auth().currentUser.uid;
        const readPerm = "permissionRead."+ uid;
        const writePerm = "permissionWrite."+ uid;
        // for recycle bin operation.
        const deleteRead = "deleteRead."+ uid;
        const deleteWrite = "deleteWrite." +uid;

        if('deleteWrite' in data && uid in data.deleteWrite) isReadOnly = false;

        const db = firebase.firestore();
        db.collection("persons").doc(docSnapshot.id).update({
            [readPerm]: true,
            ...!isReadOnly && {[writePerm]: true},
            [deleteRead]: firebase.firestore.FieldValue.delete(),
            [deleteWrite]: firebase.firestore.FieldValue.delete(),
        })
        .then(() => {
            console.log("document restored.");
        })
        .catch(function(error) {
            console.error("failed restore document: ", error);
        });
        // called to hide form after submit. this can happen before the updates.
        this.props.history.push('/');
    }

    handleMenuChange(event){
        event.preventDefault()
        if (!this.state.menuOpen){
            this.setState({menuOpen: event.currentTarget}) 
        } else{
            this.setState({menuOpen: null})
        }
    }

    render(){
        const classes = this.props.classes;

        const listItems = this.state.recycleFS.map((docSnapshot) => {
            const data = docSnapshot.data();
            return(
                <ListItem key={docSnapshot.id} button onClick={(e)=> this.handleRestore(docSnapshot, e)}
                            divider>
                    <ListItemText primary={data.personName} style={centerText}/>
                </ListItem>
            )
        });

        
        const propMenuHandlers = {
            propMenuItems: [['Clear Recycle Bin', this.clearRecycleBin]],
            propHandleMenu: this.handleMenuChange,
            propMenuState: this.state.menuOpen
        }

        const secondAppBar = {
            backgroundColor: theme.palette.primary.light,
            fontSize: '18px',
            padding: '11px'
        }
        return(
            <div>                
                <ButtonAppBar propMenuHandlers = {propMenuHandlers}/>
                <div style={secondAppBar}>
                    Recycle Bin
                </div>
                <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center">
                <div className={classes.root}>
                
                        <List component="nav">
                            {listItems}
                        </List>
                </div>
                </Grid>

            </div>
        )
    }
}

export default withStyles(styles)(RecycleBin);


// WEBPACK FOOTER //
// ./src/components/RecycleBin.js